import React from 'react';
import { Card, Empty, Image, Pagination, Spin } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import type { PhotoData } from '../../types/dashboard';

interface PhotoSectionProps {
  photoData: PhotoData[];
  debugData?: any;
  onPhotoClick: (photo: PhotoData) => void;
  photoMeta?: {
    total: number;
    currentPage: number;
    pageSize: number;
    hasMore: boolean;
  };
  onLoadPhotoPage?: (page: number) => void;
  photoLoading?: boolean;
}

const PhotoSection: React.FC<PhotoSectionProps> = ({ photoData, debugData, onPhotoClick, photoMeta, onLoadPhotoPage, photoLoading }) => {
  const displayCount = photoMeta ? photoMeta.total : photoData.length;
  
  return (
    <Card title={<><CameraOutlined /> 写真履歴 ({displayCount}件)</>} style={{ marginBottom: 16 }}>
      <details style={{ marginBottom: 8, fontSize: '12px' }}>
        <summary>🔍 写真 API応答</summary>
        <pre style={{ background: '#f5f5f5', padding: 8, fontSize: '10px', overflow: 'auto', maxHeight: 200 }}>
          {JSON.stringify(debugData?.photos, null, 2)}
        </pre>
      </details>
      {photoData.length > 0 ? (
        <div>
          <Spin spinning={photoLoading} size="large" style={{ minHeight: 200, fontSize: '24px' }} indicator={<div className="ant-spin-dot ant-spin-dot-spin" style={{ fontSize: '48px' }}><i className="ant-spin-dot-item"></i><i className="ant-spin-dot-item"></i><i className="ant-spin-dot-item"></i><i className="ant-spin-dot-item"></i></div>}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))', gap: 8, marginBottom: 16 }}>
              {photoData.map((photo) => (
                <div key={photo.id} style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => onPhotoClick(photo)}>
                  <Image
                    width={80}
                    height={60}
                    src={photo.thumbnail_url || photo.s3_url}
                    style={{ objectFit: 'cover', borderRadius: 4 }}
                    placeholder={<div style={{ width: 80, height: 60, backgroundColor: '#f0f0f0', borderRadius: 4 }} />}
                    preview={false}
                  />
                  <div style={{ fontSize: '10px', color: '#999', marginTop: 4 }}>
                    {new Date((photo.captured_at || '').replace(/Z$/, '')).toLocaleTimeString()}
                  </div>
                </div>
              ))}
            </div>
          </Spin>
          {photoMeta && photoMeta.total > photoMeta.pageSize && (
            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <Pagination
                current={photoMeta.currentPage}
                total={photoMeta.total}
                pageSize={photoMeta.pageSize}
                onChange={onLoadPhotoPage}
                showSizeChanger={false}
                showQuickJumper={false}
                showTotal={(total, range) => `${range[0]}-${range[1]} / ${total}件`}
              />
            </div>
          )}
        </div>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="写真データがありません" />
      )}
    </Card>
  );
};

export default PhotoSection;